import React, { memo } from 'react'

const ConditionallyRender = memo(({ children, when, ...props }) => {
  
    if (when) {
        return (
            <div {...props}>
                {children}
            </div>

        )
    }
    return null

})

export default ConditionallyRender
